module.exports = __webpack_public_path__ + "images/symbols.svg?e385ca3a570bceab25dc9ea41e484ae9";